import { useRef } from "react";

export function useAsRef<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
